import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getPayTermsList } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const PaymentTermsList = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  selectedProduct,
  index,
  disabled,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [fetchResponse, setFetchResponse] = useState([])
  const loadOptions = async () => {
    setIsLoading(true)
    const data = await getPayTermsList()
    setIsLoading(false)
    const response = data?.data?.map(dta => {
      return {
        label: dta?.name && ucfirst(dta.name),
        value: dta.id,
        ...dta,
      }
    })
    if (index == 0) {
      setFetchResponse(response)
    } else {
      const usedPayroll = selectedProduct?.map(
        dt => dt?.pay_term?.id != "" && dt?.pay_term?.id
      )
      setFetchResponse(() => {
        const unUsedPayroll = response.filter(item1 => {
          return !usedPayroll?.some(item2 => item2 === item1.value)
        })
        return unUsedPayroll
      })
    }
  }
  useEffect(() => {
      loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={fetchResponse}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              isDisabled={disabled ? true : false}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.querySelector(
                target ? target : ".modal"
              )}
            />
          )
        }}
      />
    </div>
  )
}

export default PaymentTermsList
